import { jt, t } from 'ttag'
import { connect } from 'react-redux'
import React from 'react'
import { Modal, OverlayTrigger, Popover } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { CSSTransitionGroup } from 'react-transition-group'

import LinkGenerator from './LinkGenerator'
import MediaKit from './MediaKit'
import UpgradeOptions from './UpgradeOptions'

import { trackOutboundLink } from '../../actions.js'
import { updatePageTitle } from '../../actions/pageInfo'
import { browserHistory } from '../../Routes'

class EducatorCorner extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      transitionLeft: false
    }
  }

  componentDidMount() {
    this.props.dispatch(updatePageTitle(t`Educator's Corner`))
  }

  componentWillUnmount() {
    this.props.dispatch(updatePageTitle(null))
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.match?.params.modalId === 'upgrades') {
      console.log('in up', nextProps)

      if (
        this.props.match?.params.modalSubId !== nextProps.match?.params.match?.modalSubId
      ) {
        if (
          this.props.match?.params.modalSubId === 'premium' ||
          (this.props.match?.params.modalSubId === 'free' &&
            nextProps.match?.params.modalSubId === 'basic')
        ) {
          console.log(
            'should move left, from: ',
            this.props.match?.params.modalSubId,
            nextProps.match?.params.modalSubId
          )

          this.setState({
            ...this.state,
            transitionLeft: true
          })
        } else {
          console.log(
            'should move right, from: ',
            this.props.match?.params.modalSubId,
            nextProps.match?.params.modalSubId
          )
          this.setState({
            ...this.state,
            transitionLeft: false
          })
        }
      }

      console.log(this.state)
    }
  }

  dismissModal = () => {
    browserHistory.push('/educators')
  }

  outputCheck = (isChecked = false, text, subpage, popover) => {
    //  const imgUrl = isChecked ?
    return (
      <li className={isChecked ? 'active' : 'inactive'}>
        <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popover}>
          <Link to={`/educators/upgrades/${subpage}`}>{text}</Link>
        </OverlayTrigger>
      </li>
    )
  }

  getVideoTutorialUrl = () => {
    switch (dynamicValues.tenantId) {
      case 'pennsylvania':
        return 'https://www.youtube.com/playlist?list=PLL5OIPQugrJJ-V0Xwsn0z_wL__Z7LxSeh'
      case 'california':
        return 'https://www.youtube.com/playlist?list=PLL5OIPQugrJKUbDS7Wz7VLshy83tE4q4G'
      default:
        return 'https://www.youtube.com/playlist?list=PLL5OIPQugrJKK1x8Dz4nHoZznqQ5KRDCT'
    }
  }

  bubbleFour = () => {
    if (dynamicValues.tenantId === 'california') {
      const calUrl = 'https://www.calcareercenter.org/'

      return [
        <a
          href={calUrl}
          onClick={e => {
            e.preventDefault()
            trackOutboundLink(calUrl)
          }}
          target="_blank"
          rel="noreferrer">
          <div className="floatdisc">
            <img src="/images/california/new/educatorcorner/H2-CCZ-Illutrations-EducatorsCorner-0818-v1.0_CaliforniaCareerCenter.svg" />
          </div>
          California Career Center
        </a>,
        <p>
          {t`A free resource provided by the California Career Resource Network which contains content
                       for students, parents, and educators.`}
        </p>
      ]
    }

    if (dynamicValues.tenantId === 'pennsylvania') {
      const paUrl = 'http://www.education.pa.gov/K-12/Pages/default.aspx#tab-1'

      return [
        <a
          href={paUrl}
          onClick={e => {
            e.preventDefault()
            trackOutboundLink(paUrl)
          }}
          target="_blank"
          rel="noreferrer">
          <div className="floatdisc">
            <img src="/images/headed2/new/educators/H2-Illutrations-EducatorsCorner-0418-v1-CareerCenter.svg" />
          </div>
          {t`K-12 Resources`}
        </a>,
        <p>{t`Resources for teachers and counselors provided by the Pennsylvania Department of Education.`}</p>
      ]
    }

    return [
      <Link to="/educators/mediaKit">
        <div className="floatdisc">
          <img
            src={
              '/images/headed2/new/educators/H2-Illutrations-Mediatoolkit-0518-v1_ChooseYourLifestyle.svg'
            }
            className="img-responsive"
          />
        </div>
        {t`Media Kit`}
      </Link>,
      <p>{jt`A collection of video tutorials designed to help you get the most out of the ${this.props.dynamicValues.systemName} system.`}</p>
    ]
  }

  render() {
    console.log(this.props, dynamicValues)
    const ecBold = <b style={{ fontWeight: '600' }}>{t`Educator Account`}</b>

    return (
      <div id="educator-corner">
        <div className="main-content-ad">
          <div className="container">
            <div className="row">
              <h3
                className="section-heading"
                style={{ marginBottom: '20px', marginTop: '20px' }}>
                {t`Just for You`}
              </h3>
              <Link to="/ladder">
                <img src="/images/common/educator/2020/Banner-UTL.svg" />
              </Link>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              {dynamicValues.isSubscriber
                ? null
                : [
                    <h3 className="section-heading" style={{ marginBottom: '25px' }}>
                      {t`Your Headed2 Account`}
                    </h3>,
                    <ul className="progression-graph">
                      {this.outputCheck(
                        this.props.loggedIn,
                        t`Headed2 Account`,
                        'basic',
                        <Popover title={t`Headed2 Account`} className="styled-popover">
                          <h4>{t`Saving your work and explore in Headed2:`}</h4>
                          <ul className="free-account-list">
                            <li className="free-save">{t`Save your work`}</li>
                            <li className="free-assessment">{t`Take self-assessments`}</li>
                            <li className="free-occupations">{t`View occupations`}</li>
                            <li className="free-budgets">{t`Build budgets`}</li>
                            <li className="free-resumes">{t`Create Resumes`}</li>
                          </ul>
                        </Popover>
                      )}

                      {this.outputCheck(
                        this.props.userProfile?.hasManager ?? false,
                        t`Free Educator Account`,
                        'free',
                        <Popover
                          title={t`Free Educator Account`}
                          className="styled-popover">
                          <h4>{t`Everything in a Headed2 Account, plus:`}</h4>
                          <ul className="free-educator-account-list">
                            <li className="free-educator-manage">{t`Manage up to ${dynamicValues.defaultManageeLimit} students`}</li>
                            <li className="free-educator-lesson">{t`Build and assign basic lesson plans`}</li>
                            <li className="free-educator-messages">{t`Send messages`}</li>
                            <li className="free-educator-reports">{t`Run basic reports to monitor student progress`}</li>
                          </ul>
                        </Popover>
                      )}

                      {this.outputCheck(
                        this.props.userProfile?.isPremium ||
                          this.props.userProfile?.hasAdmin ||
                          false,
                        t`Premium Educator Account`,
                        'premium',
                        <Popover
                          title={t`Premium Educator Account`}
                          className="styled-popover">
                          <h4>{t`Everything in a Free Educator Account, plus:`}</h4>
                          <ul className="free-educator-account-list">
                            <li className="free-educator-manage">{t`Manage up to 175 students`}</li>
                            <li className="free-educator-lesson">{t`Access to pre-loaded lesson plans`}</li>
                            <li className="free-educator-messages">{t`Unlimited file storage`}</li>
                            <li className="free-educator-reports">{t`Enhanced lesson plans, allowing for videos, attachments, and surveys`}</li>
                          </ul>
                        </Popover>
                      )}
                    </ul>
                  ]}
            </div>
          </div>
        </div>

        <div className="container" style={{ marginTop: '25px' }}>
          <h3 className="section-heading">{t`Other Resources for Educators`}</h3>
          <div className="row">
            <ul className="with-bullet">
              <li className={'col-md-3 col-xs-6'}>
                <a href="/guide/userguide">
                  <div className="floatdisc">
                    <img
                      src={
                        '/images/headed2/new/educators/H2-Illutrations-EducatorsCorner-0418-v1_UserGuide.svg'
                      }
                      className="img-responsive"
                    />
                  </div>
                  {t`User's Guide`}
                </a>
                <p>{jt`Information about the functionality in the ${this.props.dynamicValues.systemName} system and documentation on their use.`}</p>
              </li>
              <li className={'col-md-3 col-xs-6'}>
                <a href={this.getVideoTutorialUrl()} target="_blank" rel="noreferrer">
                  <div className="floatdisc">
                    <img
                      src={
                        '/images/headed2/new/educators/H2-Illutrations-EducatorsCorner-0418-v1_VideoTutorials.svg'
                      }
                      className="img-responsive"
                    />
                  </div>
                  {t`Video Tutorials`}
                </a>
                <p>{jt`A collection of video tutorials designed to help you get the most out of the ${this.props.dynamicValues.systemName} system.`}</p>
              </li>
              <li className={'col-md-3 col-xs-6'}>
                <Link to="/educators/linkBuilder">
                  <div className="floatdisc">
                    <img
                      src={'/images/common/educator/2020/LinkGenerator.svg'}
                      className="img-responsive"
                    />
                  </div>
                  {t`Link Generator`}
                </Link>
                <p>{jt`Want to add a link to us on your website? Use the link builder to create HTML that you can use on your site.`}</p>
              </li>
              <li className={'col-md-3 col-xs-6'}>{this.bubbleFour()}</li>
            </ul>
          </div>
        </div>
        <Modal
          bsSize="large"
          backdrop="static"
          show={this.props.match?.params.modalId === 'linkBuilder'}
          onHide={this.dismissModal}>
          <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={this.dismissModal}>
              <span aria-hidden="true">×</span>
            </button>
            <h2>{t`Link Generator`}</h2>
          </Modal.Header>
          <Modal.Body>
            <LinkGenerator educatorportal={this.props.educatorportal} />
          </Modal.Body>
        </Modal>
        <Modal
          bsSize="large"
          show={this.props.match?.params.modalId === 'mediaKit'}
          onHide={this.dismissModal}>
          <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={this.dismissModal}>
              <span aria-hidden="true">×</span>
            </button>
            <h2>{t`Media Kit`}</h2>
          </Modal.Header>
          <Modal.Body>
            <MediaKit />
          </Modal.Body>
        </Modal>
        <Modal
          bsSize="large"
          show={this.props.match?.params.modalId === 'upgrades'}
          onHide={this.dismissModal}>
          <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={this.dismissModal}>
              <span aria-hidden="true">×</span>
            </button>
            <h2>{t`Headed2 Account Options`}</h2>
          </Modal.Header>
          <Modal.Body>
            <div style={{ position: 'relative', overflow: 'hidden ' }}>
              <CSSTransitionGroup
                component="div"
                transitionName={
                  this.state.transitionLeft ? 'h2animate-home' : 'h2animate'
                }
                transitionEnterTimeout={400}
                transitionLeaveTimeout={400}>
                {React.cloneElement(
                  <UpgradeOptions
                    selectedItem={this.props.match?.params?.modalSubId ?? null}
                  />,
                  { key: this.props.match?.params?.modalSubId ?? null }
                )}
              </CSSTransitionGroup>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      loggedIn: !!(
        state.authenticationState.userProfile &&
        state.authenticationState.userProfile.userDisplayName
      ),
      userProfile: state.authenticationState.userProfile,
      educatorportal: state.educatorportal,
      dynamicValues
    }
  },
  dispatch => ({
    dispatch
  })
)(EducatorCorner)
